<template>
  <div>
    <div class="row mt-5">
      <div class="col text-center">
        <h5>Embalagens Vazias</h5>
      </div>
    </div>
    <hr />

    <div v-if="token.role === 'CO' || token.cadastra">
      <div class="row">
        <div class="col">
          <button
            type="button"
            class="btn btn-block btn-primary btn-raised"
            data-toggle="modal"
            data-target="#retiradaModal"
            v-if="!token.somenteLeitura"
          >+ Cadastrar Retirada</button>
          <hr />
        </div>
        <div class="col">
          <button
            type="button"
            class="btn btn-block btn-primary btn-raised"
            data-toggle="modal"
            data-target="#devolvidaModal"
            v-if="!token.somenteLeitura"
          >+ Cadastrar devolução</button>
          <hr />
        </div>
      </div>
    </div>

    <div v-if="token.role === 'CO'">
      <div class="row">
        <div class="col">
          <div id="accordion">
            <div class="card">
              <div
                class="card-header"
                id="hRetirada"
                data-toggle="collapse"
                data-target="#retirada"
              >
                <h5 class="mb-0 id">Quantidade retirada</h5>
              </div>

              <div id="retirada" class="collapse" data-parent="#accordion">
                <div class="card-body">
                  <ul class="list-group">
                    <li class="list-group-item list-group-item-action d-flex">
                      <i class="material-icons">waves</i>
                      Lavável
                      <span
                        class="badge badge-primary badge-pill ml-2"
                      >{{data.retirada.lavavel}}</span>
                    </li>
                    <li class="list-group-item list-group-item-action d-flex">
                      <i class="material-icons">block</i>
                      Não lavável
                      <span
                        class="badge badge-primary badge-pill ml-2"
                      >{{data.retirada.naoLavavel}}</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col">
          <div id="accordion">
            <div class="card">
              <div
                class="card-header"
                id="hdevolvida"
                data-toggle="collapse"
                data-target="#devolvida"
              >
                <h5 class="mb-0 id">Quantidade devolvida</h5>
              </div>

              <div id="devolvida" class="collapse" data-parent="#accordion">
                <div class="card-body">
                  <ul class="list-group">
                    <li class="list-group-item list-group-item-action d-flex">
                      <i class="material-icons">waves</i>
                      Lavável lavada
                      <span
                        class="badge badge-primary badge-pill ml-2"
                      >{{data.devolvida.lavavelLavada}}</span>
                    </li>
                    <li class="list-group-item list-group-item-action d-flex">
                      <i class="material-icons">block</i>
                      Lavável não lavada
                      <span
                        class="badge badge-primary badge-pill ml-2"
                      >{{data.devolvida.lavavelNaoLavada}}</span>
                    </li>
                    <li class="list-group-item list-group-item-action d-flex">
                      <i class="material-icons">remove_circle</i>
                      Não lavável não contaminada
                      <span
                        class="badge badge-primary badge-pill ml-2"
                      >{{data.devolvida.naoLavavelNaoContaminada}}</span>
                    </li>
                    <li class="list-group-item list-group-item-action d-flex">
                      <i class="material-icons">report_off</i>
                      Não lavável contaminada
                      <span
                        class="badge badge-primary badge-pill ml-2"
                      >{{data.devolvida.naoLavavelContaminada}}</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      class="modal fade"
      id="retiradaModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">
              Nova retirada
              <br />
              <small class="font-italic">Os valores serão somados ao atual.</small>
            </h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form>
              <div class="form-group" v-if="token.cadastra">
                <label for="cooperado">Usuário</label>
                <vue-bootstrap-typeahead
                  v-model="form.cooperado"
                  :data="cooperados"
                  :serializer="getNameLogin"
                  @hit="hit"
                  @input="onInput"
                  :disabled="form.usuario"
                />
                <p v-if="form.usuario">
                  {{form.nome}} selecionado
                  <a href="javascript:;" @click="form.usuario = ''; form.nome = ''">Desmarcar</a>
                </p>
                <small
                  class="text-danger"
                  v-if="!form.usuario"
                >* Selecione um usuário/unidade previamente cadastrado, caso não esteja listando cadastre o mesmo no modulo de usuários.</small>
              </div>

              <div class="form-group">
                <label for="lavavel" class="col-form-label">Lavável:</label>
                <input
                  type="number"
                  @focus="form.retirada.lavavel === 0 ? form.retirada.lavavel = '' : null"
                  v-model="form.retirada.lavavel"
                  class="form-control"
                  id="lavavel"
                />
              </div>
              <div class="form-group">
                <label for="naolavavel" class="col-form-label">Não lavável:</label>
                <input
                  type="number"
                  @focus="form.retirada.naoLavavel === 0 ? form.retirada.naoLavavel = '' : null"
                  v-model="form.retirada.naoLavavel"
                  class="form-control"
                  id="naoLavavel"
                />
              </div>
            </form>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary btn-raised mr-2"
              data-dismiss="modal"
            >Fechar</button>
            <button
              type="button"
              class="btn btn-primary btn-raised"
              @click="updateRetirada()"
            >Cadastrar</button>
          </div>
        </div>
      </div>
    </div>

    <div
      class="modal fade"
      id="devolvidaModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel2"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">
              Nova devolução
              <br />
              <small class="font-italic">Os valores serão somados ao atual.</small>
            </h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form>
              <div class="form-group" v-if="token.cadastra">
                <label for="cooperado">Cliente</label>
                <vue-bootstrap-typeahead
                  v-model="form.cooperado"
                  :data="cooperados"
                  :serializer="getNameLogin"
                  @hit="hit"
                  @input="onInput"
                  :disabled="form.usuario"
                />
                <p v-if="form.usuario">
                  {{form.nome}} selecionado
                  <a href="javascript:;" @click="form.usuario = ''; form.nome = ''">Desmarcar</a>
                </p>
                <small
                  class="text-danger"
                  v-if="!form.usuario"
                >* Selecione um usuário/unidade previamente cadastrado, caso não esteja listando cadastre o mesmo no modulo de usuários.</small>
              </div>

              <div class="form-group">
                <label for="lavavelLavada" class="col-form-label">Lavável lavada:</label>
                <input
                  type="number"
                  @focus="form.devolvida.lavavelLavada === 0 ? form.devolvida.lavavelLavada = '' : null"
                  v-model="form.devolvida.lavavelLavada"
                  class="form-control"
                  id="lavavelLavada"
                />
              </div>
              <div class="form-group">
                <label for="lavavelNaoLavada" class="col-form-label">Lavável não lavada:</label>
                <input
                  type="number"
                  @focus="form.devolvida.lavavelNaoLavada === 0 ? form.devolvida.lavavelNaoLavada = '' : null"
                  v-model="form.devolvida.lavavelNaoLavada"
                  class="form-control"
                  id="lavavelNaoLavada"
                />
              </div>
              <div class="form-group">
                <label
                  for="naoLavavelNaoContaminada"
                  class="col-form-label"
                >Não lavável não contaminada:</label>
                <input
                  type="number"
                  @focus="form.devolvida.naoLavavelNaoContaminada === 0 ? form.devolvida.naoLavavelNaoContaminada = '' : null"
                  v-model="form.devolvida.naoLavavelNaoContaminada"
                  class="form-control"
                  id="naoLavavelNaoContaminada"
                />
              </div>
              <div class="form-group">
                <label for="naoLavavelContaminada" class="col-form-label">Não lavável contaminada:</label>
                <input
                  type="number"
                  @focus="form.devolvida.naoLavavelContaminada === 0 ? form.devolvida.naoLavavelContaminada = '' : null"
                  v-model="form.devolvida.naoLavavelContaminada"
                  class="form-control"
                  id="naoLavavelContaminada"
                />
              </div>
            </form>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary btn-raised mr-2"
              data-dismiss="modal"
            >Fechar</button>
            <button
              type="button"
              class="btn btn-primary btn-raised"
              @click="updateDevolvida()"
            >Cadastrar</button>
          </div>
        </div>
      </div>
    </div>

    <div class="row" v-if="token.role === 'CA'">
      <div class="col-md-6 mb-5">
        <pie id="chart1" :chart-data="chartData1" class="mb-2"></pie>
        <button
          class="btn btn-sm btn-success btn-raised btn-block"
          type="button"
          @click="export2image(0, 'Retiradas')"
        >Download</button>
      </div>
      <div class="col-md-6">
        <pie id="chart2" :chart-data="chartData2" class="mb-2"></pie>
        <button
          class="btn btn-sm btn-success btn-raised btn-block"
          type="button"
          @click="export2image(1, 'Devolvidas')"
        >Download</button>
      </div>
    </div>
  </div>
</template>

<script>
import ls from "local-storage";
import Pie from "../../../custom/Pie";
import VueBootstrapTypeahead from "vue-bootstrap-typeahead";

export default {
  components: {
    Pie,
    VueBootstrapTypeahead
  },
  data() {
    return {
      data: {
        retirada: {},
        devolvida: {}
      },
      form: {
        usuario: "",
        retirada: {
          naoLavavel: 0,
          lavavel: 0
        },
        devolvida: {
          lavavelLavada: 0,
          lavavelNaoLavada: 0,
          naoLavavelContaminada: 0,
          naoLavavelNaoContaminada: 0
        }
      },
      cooperados: [],
      route: "/residuos/embalagens",
      chartData1: null,
      chartData2: null
    };
  },
  methods: {
    export2image: function(i, name) {
      let canvas = document
        .querySelectorAll("canvas")
        [i].toDataURL("image/png");
      let link = document.createElement("a");
      link.download = name;
      link.href = canvas;
      link.click();
    },
    remove(id) {
      this.$http.delete(`${this.route}/${id}`).then(() => {
        this.start();
      });
    },
    start: function() {
      this.$http.post(`${this.route}/list`).then(response => {
        this.data = response.data;

        this.chartData1 = {
          labels: [
            `${this.data.lavavel} Retirada lavável`,
            `${this.data.naoLavavel} Retirada não lavável`
          ],
          datasets: [
            {
              label: "Retiradas",
              backgroundColor: ["#0a823b", "#d98609"],
              data: [this.data.lavavel, this.data.naoLavavel]
            }
          ]
        };

        const LL = this.data.lavavelLavada;
        const LN = this.data.lavavelNaoLavada;
        const NN = this.data.naoLavavelNaoContaminada;
        const NC = this.data.naoLavavelContaminada;

        this.chartData2 = {
          labels: [
            `${LL} Lavável lavada`,
            `${LN} Lavável não lavada`,
            `${NN} Não lavável não contaminada`,
            `${NC} Não lavável contaminada`
          ],
          datasets: [
            {
              label: "Devoluções",
              backgroundColor: ["#87ABCD", "#DDD975", "#B07143", "#AD6455"],
              data: [LL, LN, NN, NC]
            }
          ]
        };
      });
    },
    updateRetirada: function() {
      if (this.token.role === "CO" || this.token.cadastra) {
        if (this.token.cadastra) {
          this.form.retirada.usuario = this.form.usuario;
        }

        this.$http
          .post(`${this.route}/updateRetirada`, this.form.retirada)
          .then(response => {
            if (response.data.success) {
              $("#retiradaModal").modal("hide");
              this.start();
              this.$toasted.show(
                "Atualizado com sucesso!",
                this.$custom.success
              );
              this.form.retirada.naoLavavel = 0;
              this.form.retirada.lavavel = 0;
            }
            console.log(response.data);
          });
      }
    },
    updateDevolvida: function() {
      if (this.token.role === "CO" || this.token.cadastra) {
        if (this.token.cadastra) {
          this.form.devolvida.usuario = this.form.usuario;
        }

        this.$http
          .post(`${this.route}/updateDevolvida`, this.form.devolvida)
          .then(response => {
            if (response.data.success) {
              $("#devolvidaModal").modal("hide");
              this.start();
              this.$toasted.show(
                "Atualizado com sucesso!",
                this.$custom.success
              );
              this.form.devolvida.lavavelLavada = 0;
              this.form.devolvida.lavavelNaoLavada = 0;
              this.form.devolvida.naoLavavelContaminada = 0;
              this.form.devolvida.naoLavavelNaoContaminada = 0;
            }
            console.log(response.data);
          });
      }
    },
    getNameLogin(input) {
      return `${input.login} - ${input.nome}`;
    },
    hit(input) {
      this.form.usuario = input._id;
      this.form.nome = input.nome;
      this.form.login = input.login;
    },
    onInput() {
      const coopTemQueSer = `${this.form.login} - ${this.form.nome}`;
      if (!this.form.usuario || this.form.cooperado !== coopTemQueSer) {
        this.form.nome = "";
        this.form.login = "";
        this.form.usuario = "";
      }
    }
  },
  beforeMount() {
    this.start();

    if (this.token.cadastra) {
      this.$http.post(`/residuos/coleta/cooperados`).then(response => {
        if (response.data) this.cooperados = response.data;
      });
    }
  }
};
</script>

<style scoped>
.id {
  font-size: 12px;
}

.card {
  cursor: pointer;
}
</style>





// WEBPACK FOOTER //
// src/components/app/residuos/embalagens/Home.vue